<form [formGroup]="form" class="activity-filters">
    <div class="row">
        <div class="col-md-6">
            <div class="divider-container mb-2">
                <div class="line"></div>
                <span class="text">ORIGINE/OPERATOR</span>
                <div class="line"></div>
            </div>
            <div class="text-end mb-1">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onResetOrigin()"
                    title="Golește zona de origine">
                    <mat-icon class="align-middle" style="font-size:16px;height:16px;width:16px;">refresh</mat-icon>
                    Reset origine
                </button>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Instituție/Direcție</mat-label>
                        <input matInput [formControl]="directiiOriginControl" [matAutocomplete]="autoDirectiiOrigin"
                            (blur)="onDirectiiOriginBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoDirectiiOrigin="matAutocomplete" [displayWith]="displayGeneric"
                            (optionSelected)="onDirectiiOriginChange($event.option.value)">
                            <mat-option *ngIf="filteredDirectiiOrigin.length === 0" disabled>
                                Nu au fost găsite rezultate
                            </mat-option>
                            <mat-option *ngFor="let directie of filteredDirectiiOrigin" [value]="directie">
                                {{ directie.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Compartiment/Departament</mat-label>
                        <input matInput [formControl]="compartimenteOriginControl"
                            [matAutocomplete]="autoCompartimenteOrigin" (blur)="onCompartimenteOriginBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoCompartimenteOrigin="matAutocomplete" [displayWith]="displayGeneric"
                            (optionSelected)="onCompartimenteOriginSelected($event.option.value)">
                            <mat-option *ngIf="showCompartimenteOriginMessage" disabled>
                                <span
                                    *ngIf="!compartimenteOriginControl.value || compartimenteOriginControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isCompartimenteOriginLoading && compartimenteOriginControl.value && compartimenteOriginControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isCompartimenteOriginLoading && compartimenteOriginLoadComplete && compartimenteOrigin.length === 0 && compartimenteOriginControl.value && compartimenteOriginControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>
                            <mat-option *ngFor="let compartiment of compartimenteOrigin" [value]="compartiment">
                                {{ compartiment.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-12">
                <mat-form-field class="w-100">
                    <mat-label>Operator</mat-label>
                    <mat-select formControlName="origin_user_id"
                        (selectionChange)="onOperatoriOriginChange($event.value)">
                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let operator of filteredOperatoriOrigin" [value]="operator.id">
                            {{ operator.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-md-6">
            <div class="divider-container mb-2">
                <div class="line"></div>
                <span class="text">DESTINAȚIE</span>
                <div class="line"></div>
            </div>
            <div class="text-end mb-1">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="onResetDestinatie()"
                    title="Golește zona de destinatar">
                    <mat-icon class="align-middle" style="font-size:16px;height:16px;width:16px;">refresh</mat-icon>
                    Reset destinatar
                </button>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Instituție/Direcție</mat-label>
                        <input matInput [formControl]="directiiDestinatieControl"
                            [matAutocomplete]="autoDirectiiDestinatie" (blur)="onDirectiiDestinatieBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoDirectiiDestinatie="matAutocomplete" [displayWith]="displayGeneric"
                            (optionSelected)="onDirectiiDestinatieChange($event.option.value)">
                            <mat-option *ngIf="filteredDirectiiDestinatie.length === 0" disabled>
                                Nu au fost găsite rezultate
                            </mat-option>
                            <mat-option *ngFor="let directie of filteredDirectiiDestinatie" [value]="directie">
                                {{ directie.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Compartiment/Departament</mat-label>
                        <input matInput [formControl]="compartimenteDestinatieControl"
                            [matAutocomplete]="autoCompartimenteDestinatie" (blur)="onCompartimenteDestinatieBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoCompartimenteDestinatie="matAutocomplete" [displayWith]="displayGeneric"
                            (optionSelected)="onCompartimenteDestinatieSelected($event.option.value)">
                            <mat-option *ngIf="showCompartimenteDestinatieMessage" disabled>
                                <span
                                    *ngIf="!compartimenteDestinatieControl.value || compartimenteDestinatieControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isCompartimenteDestinatieLoading && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isCompartimenteDestinatieLoading && compartimenteDestinatieLoadComplete && compartimenteDestinatie.length === 0 && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>
                            <mat-option *ngFor="let compartiment of compartimenteDestinatie" [value]="compartiment">
                                {{ compartiment.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Operator</mat-label>
                        <mat-select formControlName="destinatie_user_id"
                            (selectionChange)="onOperatoriDestinatieChange($event.value)">
                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let operator of filteredOperatoriDestinatie" [value]="operator.id">
                                {{ operator.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="divider-container mb-2">
        <div class="line"></div>
        <span class="text">IDENTIFICARE DOCUMENT(E)</span>
        <div class="line"></div>
    </div>
    <div class="row">
        <div class="col-md-6" *ngIf="showDocumentNumber">
            <mat-form-field class="w-100">
                <mat-label>Număr Document(Intrare/Intern)</mat-label>
                <input matInput type="text" formControlName="document_number" />
            </mat-form-field>
        </div>
        <div class="col-md-3">
            <mat-form-field class="w-100">
                <mat-label>Dată Document(e) de la:</mat-label>
                <input matInput [max]="today" [matDatepicker]="dateInputStartPicker" formControlName="date_input_start"
                    readonly (focus)="dateInputStartPicker.open()" />
                <mat-hint>ZZ/LL/AAAA</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="dateInputStartPicker"></mat-datepicker-toggle>
                <mat-datepicker #dateInputStartPicker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-md-3">
            <mat-form-field class="w-100">
                <mat-label>Dată Document(e) până la:</mat-label>
                <input matInput [min]="form.get('date_input_start')?.value" [matDatepicker]="dateInputEndPicker"
                    formControlName="date_input_end" readonly (focus)="dateInputEndPicker.open()" />
                <mat-hint>ZZ/LL/AAAA</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="dateInputEndPicker"></mat-datepicker-toggle>
                <mat-datepicker #dateInputEndPicker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6" *ngIf="showRegistruSerie">
            <mat-form-field class="w-100">
                <mat-label>Registru/Serie</mat-label>
                <mat-select formControlName="id_serie">
                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                    <mat-option *ngFor="let serie of registreActiveSwitch" [value]="serie.id">
                        {{ serie.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Categorii Document (intrare / intern / ieșire)</mat-label>
                <mat-select formControlName="id_categorii" multiple>
                    <mat-option *ngFor="let cat of categoriiActive" [value]="cat.id">
                        {{ cat.name }}
                    </mat-option>
                </mat-select>
                <mat-hint>Lasă gol pentru toate categoriile.</mat-hint>
            </mat-form-field>
        </div>
        <div class="col-md-6" *ngIf="showRegistruType">
            <mat-form-field class="w-100">
                <mat-label>Tip raport</mat-label>
                <mat-select formControlName="registru_type">
                    <mat-option *ngFor="let tip of tipRapoarte" [value]="tip.id">
                        {{ tip.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-md-3">
            <mat-form-field class="w-100">
                <mat-label>Sursă document</mat-label>
                <mat-select formControlName="source_id">
                    <mat-option [value]="-1">-- Toate sursele --</mat-option>
                    <mat-option *ngFor="let sursa of surseActive" [value]="sursa.id">
                        {{ sursa.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-3">
            <mat-form-field class="w-100">
                <mat-label>Tip document</mat-label>
                <input matInput [formControl]="tipDocumentControl" [matAutocomplete]="autoTipDocument"
                    (blur)="onTipDocumentBlur()" placeholder="caută tip document…" />
                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                <mat-autocomplete #autoTipDocument="matAutocomplete" [displayWith]="displayGeneric"
                    (optionSelected)="onTipDocumentSelected($event.option.value)">
                    <mat-option *ngIf="isTipDocumentLoading" disabled>Căutare...</mat-option>
                    <mat-option
                        *ngIf="!isTipDocumentLoading && filteredTipuriDocument.length === 0 && tipDocumentControl.value && tipDocumentControl.value.length >= 2"
                        disabled>
                        Nu au fost găsite rezultate
                    </mat-option>
                    <mat-option *ngFor="let tip of filteredTipuriDocument" [value]="tip">
                        {{ tip.name }}
                    </mat-option>
                </mat-autocomplete>
                <mat-hint>Min. 2 caractere. Gol = toate.</mat-hint>
            </mat-form-field>
        </div>
        <div class="col-md-3">
            <mat-form-field class="w-100">
                <mat-label>Stadiu activitate</mat-label>
                <mat-select formControlName="activity_status" multiple>
                    <mat-option *ngFor="let st of activityStatusOptions" [value]="st.id">
                        {{ st.name }}
                    </mat-option>
                </mat-select>
                <mat-hint>Gol = toate stadiile.</mat-hint>
            </mat-form-field>
        </div>
        <div class="col-md-3">
            <mat-form-field class="w-100">
                <mat-label>Termen (intrate/interne)</mat-label>
                <mat-select formControlName="term_status" multiple>
                    <mat-option *ngFor="let t of termStatusOptions" [value]="t.id">
                        {{ t.name }}
                    </mat-option>
                </mat-select>
                <mat-hint>Gol = toate termenele.</mat-hint>
            </mat-form-field>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-md-4">
            <button type="button" (click)="onReset()" class="btn-general btn-reset w-100">
                <mat-icon>refresh</mat-icon>
                <span>Resetează Filtre</span>
            </button>
        </div>
        <div class="col-md-8">
            <button type="button" (click)="onSearch()" class="btn-general btn-search w-100">
                <mat-icon>search</mat-icon>
                <span>Afișare</span>
            </button>
        </div>
    </div>
</form>
